import { QueryModelCore } from "@/core/model.core";

export default class Exam {
  /**
   * 获取考试列表
   */
  async getExamPageList(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/getExamPage').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 考试详情
   */
  async getExamHome(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/getExam').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 考试结果答案解析
   */
  async getExamResult(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/answerShow').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 考试结果答案解析
   */
  async examPreviewDetail(params) {
    const result = await new QueryModelCore('/api-admin/exam/preview').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 考试开始
   */
  async getExamStart(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/examStart').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 提交试卷(单题)
   */
  async submitExamOption(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/submitExamOption').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 提交试卷(整卷)
   */
  async submitExam(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/submitExam').post(params);
    const { dataMap } = result;
    return dataMap;
  }

    /**
   * 校验是否能答题
   */
    async checkExamStatus(params) {
      const result = await new QueryModelCore('/api-admin/app/exam/checkExamStatus').post(params);
      const { dataMap } = result;
      return dataMap;
    }
}